
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateTicketDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(150)]),
    priority: new FormControl<string | undefined>('PRIORITY_1', [Validators.required]),
    channel: new FormControl<string | undefined>(undefined),
    preferredChannel: new FormControl<string | undefined>(undefined),
    remarks: new FormControl<string | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    projectId: new FormControl<number | undefined>(undefined),
    calculationitemId: new FormControl<number | undefined>(undefined),
    preferredMailId: new FormControl<number | undefined>(undefined),
    preferredPhoneId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    assignedUserId: new FormControl<number | undefined>(undefined),
})
;
}
      